export default {
  name: 'InputText',
  props: ['field', 'value'],
  data: function data() {
    return {
      model: this.value
    };
  },
  emits: ['input'],
  watch: {
    model: function model(value) {
      this.$emit('input', value);
    }
  }
};